import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import moment from '../../../lib/moment.js'
import shortid from 'shortid'

export const MixedChartTable = class extends React.PureComponent {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    const efficiencySummary = get(nextProps, 'efficiencySummary')
    if (efficiencySummary
      && JSON.stringify(efficiencySummary) !== JSON.stringify(get(prevState, 'efficiencySummary'))) {
      set(tempState, 'efficiencySummary', efficiencySummary)
    }
    return tempState
  }

  state={ efficiencySummary: [] }

  renderHeader = () => {
    const widthLeft = get(this.props, 'widthLeft')
    const efficiencySummary = this.state.efficiencySummary
    let prevYear = ''
    return (
      <div>
        <YearRow>
          <LabelRow>
            <div style={ { width: widthLeft, display: 'flex', flexDirection: 'row' } } />
          </LabelRow>
          { efficiencySummary.map(month => {
            const notEqual = moment(get(month, 'month'), 'YYYY-MM').year() !== prevYear
            if (notEqual) {
              prevYear = moment(get(month, 'month'), 'YYYY-MM').year()
              return (
                <YearCol
                  key={ shortid() }
                  style={ {
                    borderLeft: notEqual ? '1px solid #CCCCCC' : '',
                  } }
                >
                  { moment(get(month, 'month'), 'YYYY-MM').year() }
                </YearCol>
              )
            }
            return <YearCol key={ shortid() } />
          }) }
        </YearRow>
        <MonthRow style={ { borderBottom: 'none' } }>
          <LabelRow>
            <div style={ { width: get(this.props, 'widthLeft'), display: 'flex', flexDirection: 'row' } } />
          </LabelRow>
          { efficiencySummary.map(month => {
            return (
              <MonthCol key={ shortid() }>
                { moment(get(month, 'month'), 'YYYY-MM').format('MMM') }
              </MonthCol>
            )
          }) }
        </MonthRow>
      </div>
    )
  }

  renderDetail = () => {
    const widthLeft = get(this.props, 'widthLeft')
    const efficiencySummary = this.state.efficiencySummary
    return (
      <div style={ { display: 'flex', flexDirection: 'column' } }>
        <MonthRow>
          <LabelRow>
            <LabelWrapper width={ widthLeft }>
              { widthLeft > 50 && <Label>Headcount</Label> }
              { widthLeft > 50 && <Circle>?</Circle> }
              <div className='tooltip'>{ `Number of Headcounts` }</div>
              <Legend color='#FFD600' />
            </LabelWrapper>
          </LabelRow>
          { efficiencySummary.map((summary, key) => {
            return (
              <SummaryCol
                key={ shortid() }
                color={ key === 6 ? '#f8e3e2' : 'white' }
              >
                { parseFloat(get(summary, 'headcount', 0)).toFixed(2) }
              </SummaryCol>
            )
          }) }
        </MonthRow>
        <MonthRow>
          <LabelRow>
            <LabelWrapper width={ widthLeft }>
              { widthLeft > 50 && <Label>Chargeable (+Forecast) (%)</Label> }
              { widthLeft > 50 && <Circle>?</Circle> }
              <div className='tooltip'>{ `The percentage of Chargeable (on-project and forecast projects)` }</div>
              <Legend color='#CE152C' />
            </LabelWrapper>
          </LabelRow>
          { efficiencySummary.map((summary, key) => {
            return (
              <SummaryCol
                key={ shortid() }
                color={ key === 6 ? '#f8e3e2' : '#ecf5fb' }
              >
                { parseFloat(get(summary, 'chargeablePercent', 0)).toFixed(2) }
              </SummaryCol>
            )
          }) }
        </MonthRow>
        <MonthRow>
          <LabelRow>
            <LabelWrapper width={ widthLeft }>
              { widthLeft > 50 && <Label>Chargeable (on-project) (%)</Label> }
              { widthLeft > 50 && <Circle>?</Circle> }
              <div className='tooltip'>{ `The percentage of Chargeable (on-project: implementing and done)` }</div>
              <Legend color='#666633' />
            </LabelWrapper>
          </LabelRow>
          { efficiencySummary.map((summary, key) => {
            return (
              <SummaryCol
                key={ shortid() }
                color={ key === 6 ? '#f8e3e2' : '#ecf5fb' }
              >
                { parseFloat(get(summary, 'onProjectPercent', 0)).toFixed(2) }
              </SummaryCol>
            )
          }) }
        </MonthRow>
        <MonthRow>
          <LabelRow>
            <LabelWrapper width={ widthLeft }>
              { widthLeft > 50 && <Label>Internal Project (%)</Label> }
              { widthLeft > 50 && <Circle>?</Circle> }
              <div className='tooltip'>{ `The percentage of Internal Projects` }</div>
              <Legend color='#FF66FF' />
            </LabelWrapper>
          </LabelRow>
          { efficiencySummary.map((summary, key) => {
            return (
              <SummaryCol
                key={ shortid() }
                color={ key === 6 ? '#f8e3e2' : '#ecf5fb' }
              >
                { parseFloat(get(summary, 'internalsPercent', 0)).toFixed(2) }
              </SummaryCol>
            )
          }) }
        </MonthRow>

        <MonthRow>
          <LabelRow>
            <LabelWrapper width={ widthLeft }>
              { widthLeft > 50 && <Label>Non-Chargeable (%)</Label> }
              { widthLeft > 50 && <Circle>?</Circle> }
              <div className='tooltip'>{ `The percentage of Non-Changeable` }</div>
              <Legend color='#66FFFF' />
            </LabelWrapper>
          </LabelRow>
          { efficiencySummary.map((summary, key) => {
            return (
              <SummaryCol
                key={ shortid() }
                color={ key === 6 ? '#f8e3e2' : '#ecf5fb' }
              >
                { parseFloat(get(summary, 'nonChargeablePercent', 0)).toFixed(2) }
              </SummaryCol>
            )
          }) }
        </MonthRow>

        <MonthRow>
          <LabelRow>
            <LabelWrapper width={ widthLeft }>
              { widthLeft > 50 && <Label>Chargeable (+Forecast)</Label> }
              { widthLeft > 50 && <Circle>?</Circle> }
              <div className='tooltip'>{ `For on-project and forecast projects ` }</div>
              <Legend color='#F598A4' />
            </LabelWrapper>
          </LabelRow>
          { efficiencySummary.map((summary, key) => {
            return (
              <SummaryCol
                key={ shortid() }
                color={ key === 6 ? '#f8e3e2' : '#fff4e7' }
              >
                { parseFloat(get(summary, 'chargeable', 0)).toFixed(2) }
              </SummaryCol>
            )
          }) }
        </MonthRow>
        <MonthRow>
          <LabelRow>
            <LabelWrapper width={ widthLeft }>
              { widthLeft > 50 && <Label>Chargeable (on-project)</Label> }
              { widthLeft > 50 && <Circle>?</Circle> }
              <div className='tooltip'>{ `For projects that the status are implementing or done` }</div>
              <Legend color='#92D050' />
            </LabelWrapper>
          </LabelRow>
          { efficiencySummary.map((summary, key) => {
            return (
              <SummaryCol
                key={ shortid() }
                color={ key === 6 ? '#f8e3e2' : '#fff4e7' }
              >
                { parseFloat(get(summary, 'onProject', 0)).toFixed(2) }
              </SummaryCol>
            )
          }) }
        </MonthRow>
        <MonthRow>
          <LabelRow>
            <LabelWrapper width={ widthLeft }>
              { widthLeft > 50 && <Label>Internal Project</Label> }
              { widthLeft > 50 && <Circle>?</Circle> }
              <div className='tooltip'>{ `For specific projects and common projects that are checked as display on "Resource Utilization"` }</div>
              <Legend color='#7030A0' />
            </LabelWrapper>
          </LabelRow>
          { efficiencySummary.map((summary, key) => {
            return (
              <SummaryCol
                key={ shortid() }
                color={ key === 6 ? '#f8e3e2' : '#fff4e7' }
              >
                { parseFloat(get(summary, 'internalsAndNonCharge', 0)).toFixed(2) }
              </SummaryCol>
            )
          }) }
        </MonthRow>
        <MonthRow>
          <LabelRow>
            <LabelWrapper width={ widthLeft }>
              { widthLeft > 50 && <Label>Non-Chargeable</Label> }
              { widthLeft > 50 && <Circle>?</Circle> }
              <div className='tooltip'>{ `For common projects that are not displayed on Resource Utilization ` }</div>
              <Legend color='#0070C0' />
            </LabelWrapper>
          </LabelRow>
          { efficiencySummary.map((summary, key) => {
            return (
              <SummaryCol
                key={ shortid() }
                color={ key === 6 ? '#f8e3e2' : '#fff4e7' }
              >
                { parseFloat(get(summary, 'nonChargeable', 0)).toFixed(2) }
              </SummaryCol>
            )
          }) }
        </MonthRow>
        {/* <MonthRow>
          <LabelRow>
            <LabelWrapper width={ widthLeft }>
              { widthLeft > 50 && <Label>Utilization (%)</Label> }
              { widthLeft > 50 && <Circle>?</Circle> }
              <div className='tooltip'>{ `Utilization is chargeable projects and internal projects.` }</div>
              <Legend color='#000' />
            </LabelWrapper>
          </LabelRow>
          { efficiencySummary.map((summary, key) => {
            return (
              <SummaryCol
                key={ shortid() }
                color={ key === 6 ? '#f8e3e2' : 'white' }
              >
                { parseFloat(get(summary, 'utilizationPercent', 0)).toFixed(2) }
              </SummaryCol>
            )
          }) }
        </MonthRow> */}
      </div>
    )
  }

  render() {
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        { this.renderHeader() }
        { this.renderDetail() }
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  width: 100%;
  margin-top: 10px;
  margin-bottom: 20px;

  .tooltip {
    width: 200px;
    max-width: 200px;
    font-size: 12px;
    top: 30px;
    background-color: #fff;
    padding: 5px;
    box-shadow: 0 1px 3px 0 rgba(0,0,0,0.3);
    transition: opacity 1s ease;
    opacity: 0;
    visibility: hidden;
  }
  
  span:hover + .tooltip,
  .tooltip:hover {
    transition: opacity 0s ease;
    transition-delay: 1s;
    opacity: 1;
    visibility: visible;
  }
`
const WrapperRow = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  // border-bottom: 1px solid #CCCCCC;
`
const MonthRow = styled(WrapperRow)`
  height: 25px;
  color: black;
  justify-content: space-around;
  align-items: center;
`
const YearRow = styled(MonthRow)`
  background-color: white;
`
const MonthCol = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  font-size: 12px;
  align-items: center;
  justify-content: center;
  background-color: #EDEDED;
  border-left: 1px solid #CCCCCC;
  border-bottom: 1px solid #CCCCCC;
  :last-child {
    border-right: 1px solid #CCCCCC;
  }
`
const YearCol = styled(MonthCol)`
  border-left: none;
  border-top: 1px solid #CCCCCC;
  background-color: white;
`
const SummaryCol = styled(MonthCol)`
  background-color: ${props => props.color};
`
const LabelRow = styled.div`
  background-color: white;
  display: flex;
  flex-direction: row;
`
const LabelWrapper = styled.div`
  width: ${props => props.width}px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
  position: relative;
`
const Label = styled.span`
  font-size: 12px;
  padding-left: 10px;
  padding-right: 10px;
`
const Legend = styled.div`
  width: 25px;
  height: 10px;
  border-radius: 10px 10px 10px 10px;
  background-color: ${props => { return props.color }};
  text-align: center;
`
const Circle = styled.span`
  font-size: 10px;
  color: #A1A1A1;
  text-align: center;
  height: 15px;
  width: 15px;
  background-color: #FFFFFF;
  border-radius: 50%;
  border: 1px solid #A1A1A1;
  margin-right: 10px;
  cursor: default;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/components/mixed-chart-table.js